module.exports = __webpack_public_path__ + "54cf98f5/img/ion_calendar-number.3ac5bd07.svg";